import { Instance, types } from "mobx-state-tree";

export const WorkOrderPOProgressBaseModel = types
  .model({
    date: types.maybeNull(types.string),
    amount: types.maybeNull(types.number),
    equipment: types.maybeNull(types.string),
    operator: types.maybeNull(types.string),
    inspector: types.maybeNull(types.string),
    completedDate: types.maybeNull(types.string),
    completedAmount: types.maybeNull(types.number),
    lossAmount: types.maybeNull(types.number),
    lossPercent: types.maybeNull(types.number),
    printPaperAmount: types.maybeNull(types.number),
    printPaperCompletedAmount: types.maybeNull(types.number),
  })
  .views((self) => ({
    get lossAmountFECalc() {
      if (self.amount == null || self.completedAmount == null) return null;
      return self.amount - self.completedAmount;
    },
  }))
  .views((self) => ({
    get lossPercentFECalc() {
      if (
        self.lossAmountFECalc == null ||
        self.amount == null ||
        self.amount === 0
      )
        return null;
      return (self.lossAmountFECalc * 100) / self.amount;
    },
  }));

export type IWorkOrderPOProgressModel = Instance<
  typeof WorkOrderPOProgressBaseModel
> | null;
